export default {};

export const copyAutoBreakStateToNewUsers = ({
  newUsers,
  copiedDates,
  oldIdToNewUserIdMap,
  copiedFromUserId,
  deletedAutoBreaksPerUser,
  editedTasksPerUser,
  usersWithAutoBreak,
  allTasks,
  autoBreakDuration = 15,
}) => {
  if (!copiedDates?.size || !newUsers?.length) {
    return {
      deletedAutoBreaksPerUser,
      editedTasksPerUser,
      tasksToAdjust: [],
    };
  }
  const newDeletedAutoBreaks = {
    ...deletedAutoBreaksPerUser,
  };
  const newEditedTasksPerUser = {
    ...editedTasksPerUser,
  };
  const tasksToAdjust = [];
  const originalUserEditedTasks = editedTasksPerUser[copiedFromUserId] ?? new Set();
  const originalUserDeletedAutoBreaks = new Set(
    deletedAutoBreaksPerUser[copiedFromUserId]?.map((deleted) => deleted.date) ?? [],
  );
  const copiedDatesArray = Array.from(copiedDates);
  newUsers.forEach((newUser) => {
    const userHasAutoBreak = usersWithAutoBreak?.has(newUser);
    const userDeletedAutoBreaks = [...deletedAutoBreaksPerUser[newUser] ?? []];
    const oldDeletedDates = new Set(userDeletedAutoBreaks.map((deleted) => deleted.date));

    // Only copy deleted auto breaks if the new user also has auto break enabled
    if (userHasAutoBreak) {
      copiedDatesArray.forEach((copiedDate) => {
        if (originalUserDeletedAutoBreaks.has(copiedDate) && !oldDeletedDates.has(copiedDate)) {
          userDeletedAutoBreaks.push({
            date: copiedDate, type: 'break',
          });
        }
      });
      newDeletedAutoBreaks[newUser] = userDeletedAutoBreaks;
    }

    const newUserEditedTasks = new Set(editedTasksPerUser[newUser] ?? new Set());
    const editIds = oldIdToNewUserIdMap[newUser] ?? [];
    editIds.forEach(({ oldId, newId }) => {
      if (originalUserEditedTasks.has(oldId)) {
        // If the new user has auto break, copy the edited state
        if (userHasAutoBreak) {
          newUserEditedTasks.add(newId.toString());
        } else {
          // If the new user does NOT have auto break, we need to add back the auto break duration
          // Find the task and adjust its endTime
          const task = allTasks?.find((t) => t.id?.toString() === newId?.toString());
          if (task) {
            tasksToAdjust.push({
              ...task,
              endTime: task.endTime + (autoBreakDuration * 60 * 1000),
            });
          }
        }
      }
    });
    newEditedTasksPerUser[newUser] = newUserEditedTasks;
  });
  return {
    deletedAutoBreaksPerUser: newDeletedAutoBreaks,
    editedTasksPerUser: newEditedTasksPerUser,
    tasksToAdjust,
  };
};
